import React, { useState } from 'react';

import { Button, FormHelperText } from '@material-ui/core';
import ButtonBase from '@material-ui/core/ButtonBase';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';

import { IMAGE } from '../../models/Resource';
import { sanitizeFileName } from '../../utils/files';

const useStyles = makeStyles((theme) => ({
  addIcon: {
    fontSize: 40,
  },
  focusVisible: {},
  helperText: {
    bottom: '0',
    left: '8px',
    position: 'absolute',
  },
  image: {
    '&:hover, &$focusVisible': {
      '& $imageBackdrop': {
        opacity: 0.3,
      },
      zIndex: 1,
    },
    backgroundColor: 'transparent',
    height: 158,
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      // Overrides inline-style
      height: 100,
      width: '100% !important',
    },
    width: '100%',
  },
  imageBackdrop: {
    backgroundColor: theme.palette.primary.main,
    bottom: 0,
    left: 0,
    opacity: 0,
    position: 'absolute',
    right: 0,
    top: 0,
    transition: theme.transitions.create('opacity'),
  },
  imageSrc: {
    bottom: 0,
    height: '100%',
    left: 0,
    objectFit: 'contain',
    opacity: 0.5,
    position: 'absolute',
    right: 0,
    top: 0,
    width: '100%',
  },
  input: {
    height: 0.1,
    opacity: 0,
    overflow: 'hidden',
    position: 'absolute',
    width: 0.1,
    zIndex: -1,
  },
  root: {
    border: '2px solid #c8c8c8',
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: 300,
    position: 'relative',
    width: '100%',
  },
}));

export default ({ imageUrl, onChange, validation, error, errorMessage }) => {
  const classes = useStyles();
  const [validationError, setValidationError] = useState(null);

  let backgroundImage = '';
  // in case it is a url and not a binary upload
  try {
    backgroundImage = imageUrl ? URL.createObjectURL(imageUrl) : null;
  } catch {
    backgroundImage = imageUrl;
  }

  const handleRemove = () => {
    onChange(null);
  };

  const handleChange = (event) => {
    setValidationError(false);
    const file = event.target.files[0];

    if (!onChange || !file) return;

    if ((validation && !validation(file)) || !file.type.includes(IMAGE)) {
      setValidationError(true);
      return;
    }

    const renamedFile = sanitizeFileName(file);
    onChange(renamedFile);
  };

  const helperText =
    validationError || error ? (
      <FormHelperText error className={classes.helperText}>
        {validationError ? errorMessage : error}
      </FormHelperText>
    ) : null;

  return (
    <div className={classes.root}>
      <input accept=".jpg,.jpeg,.png" className={classes.input} type="file" onChange={handleChange} id="file-input" />
      <ButtonBase focusRipple className={classes.image} focusVisibleClassName={classes.focusVisible} component="label" htmlFor="file-input">
        {backgroundImage && <img className={classes.imageSrc} alt="background" src={backgroundImage} />}
        <span className={classes.imageBackdrop} />
        <AddIcon color="primary" className={classes.addIcon} />
      </ButtonBase>
      {backgroundImage && <Button onClick={handleRemove}>Remove Image</Button>}
      {helperText}
    </div>
  );
};
